// dt-tracking.js
// Custom UI tracking: click + view (impression) events via data-dt-track-* attributes

document.addEventListener(
  "click",
  function (event) {
    if (!(event.target instanceof Element)) return;

    const target = event.target.closest("[data-dt-track-click]");
    if (!target) return;

    let metadata = {};
    const rawMetadata = target.getAttribute("data-dt-track-metadata");
    if (rawMetadata) {
      try {
        metadata = JSON.parse(rawMetadata);
      } catch (e) {
        console.error(
          "[dt-tracking] Invalid JSON in data-dt-track-metadata",
          e,
        );
      }
    }

    const payload = {
      event_name: target.getAttribute("data-dt-track-click"),
      location: target.getAttribute("data-dt-track-location"),
      title: target.getAttribute("data-dt-track-title"),
      metadata: metadata,
    };

    if (!(typeof Shopify !== "undefined" && Shopify.analytics)) {
      console.warn(
        "[dt-tracking] Shopify.analytics not available, event not published",
      );
      return;
    }

    // Skip preventDefault/timeout logic for modified clicks (cmd/ctrl/shift/alt,
    // or links opening in a new tab (target="_blank")
    const isModifiedClick =
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0;
    const opensNewContext = target.target === "_blank";

    const isNavigatingLink =
      target.tagName === "A" &&
      target.href &&
      !isModifiedClick &&
      !opensNewContext;

    if (isNavigatingLink) {
      event.preventDefault();

      let navigated = false;
      const navigate = () => {
        if (navigated) return;
        navigated = true;
        window.location.href = target.href;
      };

      const timeoutFallback = setTimeout(navigate, 100);

      let publishResult;
      try {
        publishResult = Shopify.analytics.publish(
          "custom_theme_click",
          payload,
        );
      } catch (e) {
        console.error(
          "[dt-tracking] Shopify.analytics.publish threw synchronously",
          e,
        );
        clearTimeout(timeoutFallback);
        navigate();
        return;
      }

      Promise.resolve(publishResult)
        .then(() => {
          clearTimeout(timeoutFallback);
          navigate();
        })
        .catch(() => {
          clearTimeout(timeoutFallback);
          navigate();
        });
    } else {
      try {
        Shopify.analytics.publish("custom_theme_click", payload);
      } catch (e) {
        console.error(
          "[dt-tracking] Shopify.analytics.publish threw synchronously",
          e,
        );
      }
    }
  },
  { passive: false },
);

document.addEventListener(
  "change",
  function (event) {
    if (!(event.target instanceof Element)) return;
    const target = event.target.closest("[data-dt-track-change]");
    if (!target || target.tagName !== "SELECT") return;

    const payload = {
      event_name: target.getAttribute("data-dt-track-change"),
      location: target.getAttribute("data-dt-track-location"),
      title: target.value,
      metadata: {},
    };

    if (typeof Shopify !== "undefined" && Shopify.analytics) {
      try {
        Shopify.analytics.publish("custom_theme_change", payload);
      } catch (e) {
        console.error(
          "[dt-tracking] Shopify.analytics.publish threw synchronously",
          e,
        );
      }
    } else {
      console.warn(
        "[dt-tracking] Shopify.analytics not available, event not published",
      );
    }
  },
  { passive: true },
);

document.addEventListener("DOMContentLoaded", () => {
  const viewElements = document.querySelectorAll("[data-dt-track-view]");
  if (!("IntersectionObserver" in window) || viewElements.length === 0) return;

  const viewObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const target = entry.target;

        const payload = {
          event_name: target.getAttribute("data-dt-track-view"),
          location: target.getAttribute("data-dt-track-location"),
          title: target.getAttribute("data-dt-track-title") || "",
        };

        if (typeof Shopify !== "undefined" && Shopify.analytics) {
          try {
            Shopify.analytics.publish("custom_theme_view", payload);
          } catch (e) {
            console.error(
              "[dt-tracking] Shopify.analytics.publish threw synchronously",
              e,
            );
          }
        } else {
          console.warn(
            "[dt-tracking] Shopify.analytics not available, event not published",
          );
        }

        observer.unobserve(target);
      });
    },
    { root: null, rootMargin: "0px", threshold: 0.3 },
  );

  viewElements.forEach((el) => viewObserver.observe(el));
});
